/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExaaPriceResponse } from '../../models/exaa-price-response';

export interface GetExaaPriceSeries$Params {
  location_id: string;
  from?: string;
  to?: string;
}

export function getExaaPriceSeries(http: HttpClient, rootUrl: string, params: GetExaaPriceSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<ExaaPriceResponse>> {
  const rb = new RequestBuilder(rootUrl, getExaaPriceSeries.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExaaPriceResponse>;
    })
  );
}

getExaaPriceSeries.PATH = '/locations/{location_id}/exaa-price-series';
